import { computed, inject, Service, Signal } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { toSignal } from '@angular/core/rxjs-interop';

@Service()
export class KidsResponsiveService {
  private breakpointObserver = inject(BreakpointObserver);

  desktopState: Signal<BreakpointState>;

  isDesktop = computed(() => this.desktopState()?.matches);

  constructor() {
    this.desktopState = toSignal(this.breakpointObserver.observe('(min-width: 900px)'));
  }
}
